import React, { useEffect, useState, useRef } from "react";
import "./imagegallery.css";
import { checkAccess } from "../utils/auth";
import axios from "axios";

// Fallback SVG placeholder (inline, always works)
const PLACEHOLDER =
    "data:image/svg+xml;utf8," +
    encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">
  <rect width="400" height="300" fill="#f0e6d2"/>
  <text x="50%" y="45%" font-family="Arial" font-size="18" fill="#8b6f47" text-anchor="middle">🕉️ Divine Image</text>
  <text x="50%" y="60%" font-family="Arial" font-size="12" fill="#a08868" text-anchor="middle">Preview unavailable</text>
</svg>`);

function ImageGallery() {
    const [categories, setCategories] = useState({});
    const [activeCategory, setActiveCategory] = useState("all");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        /* Uncomment to fetch from API
        const load = async () => {
            try {
                const response = await axios.get(
                    "https://api.contents.dharmiq.co.in/api/home/web",
                    { headers: { Accept: "application/json" } }
                );
                const apiData = response.data || {};
                const cleaned = {};
                Object.entries(apiData).forEach(([key, value]) => {
                    if (Array.isArray(value) && value.length > 0) {
                        cleaned[key] = value;
                    }
                });
                setCategories(cleaned);
            } catch (err) {
                console.error("HOME API ERROR:", err);
                setError("Failed to load gallery. Please try again.");
            } finally {
                setLoading(false);
            }
        };
        load();
        */

        // STATIC DATA (only unique categories, no duplicates)
        const apiData = {
            "slider": [
                { "_id": "s1", "name": "152a4cfc.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/152a4cfc-ab61-4de0-b99a-b9f798295e12.jpg" },
                { "_id": "s2", "name": "f66f04b6.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/f66f04b6-4777-468d-8336-c666da69737c.jpg" },
                { "_id": "s3", "name": "e3aae5fd.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/e3aae5fd-11df-4ff1-9644-50629072b800.jpg" },
                { "_id": "s4", "name": "a7c1761c.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/a7c1761c-4d8e-42af-9a39-46b68116e8e4.jpg" },
                { "_id": "s5", "name": "54af42d6.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/54af42d6-fdb9-47af-8cfa-e254c6e7dfe2.jpg" }
            ],
            "newly_added": [
                { "_id": "n1", "name": "1814c6c4.jpeg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/1814c6c4-d6da-476d-8d8a-c3455763bd4b.jpeg" },
                { "_id": "n2", "name": "03edbda0.jpeg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/03edbda0-c65f-42ad-9386-6c73f5c317b3.jpeg" },
                { "_id": "n3", "name": "952d8a64.jpeg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/952d8a64-86f4-49ac-b3ff-c7ab2f1199f6.jpeg" },
                { "_id": "n4", "name": "b7547e38.jpeg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/b7547e38-03ce-4807-8ef6-7285b96007b4.jpeg" },
                { "_id": "n5", "name": "03902b3d.jpeg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/03902b3d-92d2-428d-be66-5dc8296dea1a.jpeg" }
            ],
            "ganeshji": [
                { "_id": "g1", "name": "0e969cf5.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/0e969cf5-18ac-478f-b820-a134f45851b9.jpg" },
                { "_id": "g2", "name": "8e4c455c.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/8e4c455c-b454-43e5-b71c-94db5383ca42.jpg" },
                { "_id": "g3", "name": "feebd326.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/feebd326-1041-4e8b-a08e-2171aab2ea46.jpg" },
                { "_id": "g4", "name": "0bcfc1d7.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/0bcfc1d7-e2c4-476b-a685-ecbfcb7d474c.jpg" }
            ],
            "mahakalji": [
                { "_id": "m1", "name": "49e1212f.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/49e1212f-befb-4da9-a8cd-067b5ba272f6.jpg" },
                { "_id": "m2", "name": "4d109e2c.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/4d109e2c-190a-43ee-9210-516abc009c99.jpg" },
                { "_id": "m3", "name": "d140266c.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/d140266c-6867-43bd-9b6e-25e414ef0a69.jpg" },
                { "_id": "m4", "name": "b39ac94d.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/b39ac94d-0e5d-4de6-a83e-bd4daac483a2.jpg" }
            ],
            "shri_ramji": [
                { "_id": "r1", "name": "24d71778.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/24d71778-e6d2-4178-be29-e3de312fac12.jpg" },
                { "_id": "r2", "name": "791dbd05.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/791dbd05-9ebc-4b84-8416-7f93328bc1d3.jpg" },
                { "_id": "r3", "name": "d1875aab.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/d1875aab-e4f1-4e8c-a347-fbecf5ba0ded.jpg" }
            ],
            "hanumanji": [
                { "_id": "h1", "name": "af07f038.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/af07f038-e253-4e5f-a225-f4ba319f3b89.jpg" },
                { "_id": "h2", "name": "3105e403.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/3105e403-d88d-4357-9a1e-274681842150.jpg" },
                { "_id": "h3", "name": "d14de71e.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/d14de71e-210d-460b-ad75-f91cc8014bfc.jpg" }
            ],
            "krishnaji": [
                { "_id": "k1", "name": "c0312c33.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/c0312c33-f916-4cef-98ec-f60fa94e606d.jpg" },
                { "_id": "k2", "name": "2c7bcba2.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/2c7bcba2-8bfc-4046-9432-b3af77e74241.jpg" },
                { "_id": "k3", "name": "dd73eed1.jpg", "url": "https://pub-e672bf9b0d8143c88eca3ec4a97c2e74.r2.dev/dd73eed1-7361-4679-8cf9-e04c788d93ce.jpg" }
            ]
        };

        const cleaned = {};
        Object.entries(apiData).forEach(([key, value]) => {
            if (Array.isArray(value) && value.length > 0) {
                cleaned[key] = value;
            }
        });

        setCategories(cleaned);
        setLoading(false);
    }, []);

    // Deduplicated flat list
    const seen = new Set();
    const allImages = Object.values(categories)
        .flat()
        .filter((img) => {
            if (!img || !img._id || seen.has(img._id)) return false;
            seen.add(img._id);
            return true;
        });

    const displayedImages =
        activeCategory === "all"
            ? allImages
            : categories[activeCategory] || [];

    const categoryLabels = {
        slider: "Slider",
        newly_added: "Newly Added",
        ganeshji: "Ganesh Ji",
        mahakalji: "Mahakal Ji",
        shri_ramji: "Shri Ram Ji",
        hanumanji: "Hanuman Ji",
        krishnaji: "Krishna Ji",
    };

    const handleDownload = (image) => {
        try {
            if (typeof checkAccess === "function" && !checkAccess()) return;
        } catch (e) {
            console.warn("checkAccess threw, proceeding anyway:", e);
        }

        const url = image.url || image.image || image.image_url;
        if (!url) return;

        const title = image.title || (image.name ? image.name.replace(/\.[^.]+$/, "") : "image");
        const link = document.createElement("a");
        link.href = url;
        link.download = `${title.replace(/\s+/g, "-").toLowerCase()}.jpg`;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    /* ---------- SKELETON ---------- */
    if (loading) {
        return (
            <section className="gallery-section animate-on-scroll">
                <div className="custom-container">
                    <div className="section-title text-center">
                        <h2>Divine Gallery</h2>
                        <p>Loading divine moments...</p>
                    </div>
                    <div className="gallery-grid">
                        {Array.from({ length: 8 }).map((_, i) => (
                            <div key={i} className="gallery-card skeleton-card">
                                <div className="skeleton skeleton-image" />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        );
    }

    /* ---------- ERROR ---------- */
    if (error) {
        return (
            <section className="gallery-section animate-on-scroll">
                <div className="custom-container">
                    <div className="section-title text-center">
                        <h2>Divine Gallery</h2>
                        <p>{error}</p>
                    </div>
                </div>
            </section>
        );
    }

    /* ---------- GALLERY ---------- */
    return (
        <section className="gallery-section animate-on-scroll">
            <div className="custom-container">
                <div className="section-title text-center">
                    <h2>Divine Gallery</h2>
                    <p>High-quality spiritual wallpapers & divine moments</p>
                </div>

                <div className="gallery-tabs">
                    <button
                        className={activeCategory === "all" ? "active" : ""}
                        onClick={() => setActiveCategory("all")}
                    >
                        All ({allImages.length})
                    </button>
                    {Object.keys(categories).map((key) => (
                        <button
                            key={key}
                            className={activeCategory === key ? "active" : ""}
                            onClick={() => setActiveCategory(key)}
                        >
                            {categoryLabels[key] || key} ({categories[key].length})
                        </button>
                    ))}
                </div>

                <div className="gallery-grid" id="galleryGrid">
                    {displayedImages.length === 0 ? (
                        <div className="text-center" style={{ gridColumn: "1 / -1", padding: "40px" }}>
                            <p>No images found.</p>
                        </div>
                    ) : (
                        displayedImages.map((image, index) => (
                            <GalleryCard
                                key={image._id || index}
                                image={image}
                                onDownload={handleDownload}
                                eager={index < 6}
                            />
                        ))
                    )}
                </div>
            </div>
        </section>
    );
}

const MAX_IMAGE_RETRIES = 3;

/* ---------- CARD ---------- */
function GalleryCard({ image, onDownload, eager = false }) {
    const [imgLoaded, setImgLoaded] = useState(false);
    const [imgError, setImgError] = useState(false);
    const [retryCount, setRetryCount] = useState(0);
    const imgRef = useRef(null);

    const imageUrl = image.url || image.image || image.image_url || PLACEHOLDER;

    const title =
        image.title ||
        (image.name ? image.name.replace(/\.[^.]+$/, "") : "Divine Image");

    useEffect(() => {
        if (imgRef.current?.complete && imgRef.current.naturalWidth > 0) {
            setImgLoaded(true);
        }
    }, [imageUrl]);

    useEffect(() => {
        if (!imgError || retryCount >= MAX_IMAGE_RETRIES) return;
        const timer = setTimeout(() => {
            setImgError(false);
            setRetryCount((c) => c + 1);
        }, 800 * (retryCount + 1));
        return () => clearTimeout(timer);
    }, [imgError, retryCount]);

    const handleManualRetry = () => {
        setRetryCount(0);
        setImgError(false);
    };

    const src =
        retryCount > 0 && imageUrl !== PLACEHOLDER
            ? `${imageUrl}${imageUrl.includes("?") ? "&" : "?"}retry=${retryCount}`
            : imageUrl;

    // Always render the img, fall back to placeholder on final error
    const finalSrc = imgError && retryCount >= MAX_IMAGE_RETRIES ? PLACEHOLDER : src;

    return (
        <div className="gallery-card">
            <div className="gallery-img-wrapper" style={{ position: "relative", minHeight: "200px", background: "#f5efe0" }}>
                {!imgLoaded && !imgError && (
                    <div className="skeleton skeleton-image" />
                )}

                <img
                    ref={imgRef}
                    src={finalSrc}
                    alt={title}
                    loading={eager ? "eager" : "lazy"}
                    decoding="async"
                    onLoad={() => setImgLoaded(true)}
                    onError={() => {
                        if (retryCount < MAX_IMAGE_RETRIES) {
                            setImgError(true);
                        } else {
                            setImgLoaded(true);
                        }
                    }}
                    onClick={imgError ? handleManualRetry : undefined}
                    style={{
                        display: "block",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        opacity: imgLoaded ? 1 : 0,
                        transition: "opacity 0.3s ease",
                        cursor: imgError ? "pointer" : "default",
                    }}
                />
            </div>

            <button
                className="download-btn"
                title="Download"
                onClick={() => onDownload(image)}
                style={{
                    position: "absolute",
                    bottom: "12px",
                    right: "12px",
                    zIndex: 3,
                    background: "rgba(255,255,255,0.9)",
                    border: "none",
                    borderRadius: "50%",
                    width: "36px",
                    height: "36px",
                    cursor: "pointer",
                    fontSize: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                }}
            >
                ↓
            </button>

            <div className="gallery-overlay">
                <div className="gallery-overlay-content">
                    <h4>{title}</h4>
                </div>
            </div>
        </div>
    );
}

export default ImageGallery;